export function setLanguage(value) {
  return {
    type: "SET_LANGUAGE",
    payload: {
      value: value,
    },
  };
}